import { Box, Typography } from '@mui/material';
import { MaintenanceModeLayout } from '../../component/layout/MaintenanceModeLayout';

interface Props {
  headlineLarge: React.ReactNode;
  headlineSmall: React.ReactNode;
  message: React.ReactNode;
}

export const MaintenanceModeView: React.FC<React.PropsWithChildren<Props>> = ({ headlineLarge, headlineSmall, message, children }) => {
  return (
    <MaintenanceModeLayout>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h1" sx={{ paddingTop: 1, paddingBottom: 2 }}>
          {headlineLarge}
        </Typography>
        <Typography variant="h3" gutterBottom>
          {headlineSmall}
        </Typography>
        <Box sx={{ marginBottom: 1.5 }}>
          <Typography
            sx={{
              color: 'inherit',
            }}
          >
            {message}
          </Typography>
        </Box>
        {children}
      </Box>
    </MaintenanceModeLayout>
  );
};
